import { all, takeEvery } from 'redux-saga/effects'
import * as actions from './http-error.actions'

import { addHttpError } from './sagas/add-http-error'

export default function* () {
  yield all([takeEvery(actions.ADD_HTTP_ERROR, addHttpError)])
}
